import * as i0 from '@angular/core';
import { NgModule, Injectable, EventEmitter, Output } from '@angular/core';
import * as i5 from '@angular/router';
import { RouterModule } from '@angular/router';
import { CoreCommonModule } from '@citi-gcg-173875/citi-common-modules';
import * as i2 from '@citi-gcg-173875/citi-mfa-ui';
import { MfaUiService, MfaUtilityService } from '@citi-gcg-173875/citi-mfa-ui';
import * as i3 from 'ng2-cookies';
import { Cookie, UnmanagedCookieService } from 'ng2-cookies';
import * as i1$1 from '@citi-gcg-173875/citi-http';
import * as i4 from '@citi-gcg-173875/citi-security';
import * as i1 from '@citi-gcg-173875/citi-utils';
import { StorageService } from '@citi-gcg-173875/citi-utils';
import { of, firstValueFrom, EMPTY, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isNil } from 'lodash';
import { Cookie as Cookie$1 } from 'ng2-cookies/ng2-cookies';

// TODO: Safely remove as no routing is required (yet)
// NGA Login Changes - remove children routes and use of configs
const NGA_LOGIN_ROUTES = [];
class NGALoginServiceRoutingModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginServiceRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: NGALoginServiceRoutingModule, imports: [i5.RouterModule], exports: [RouterModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginServiceRoutingModule, imports: [RouterModule.forChild(NGA_LOGIN_ROUTES), RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginServiceRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(NGA_LOGIN_ROUTES)],
                    exports: [RouterModule]
                }]
        }] });

class BAOLoginServiceConstants {
    constructor() {
        this.appConstants = {
            BAOUrls: {
                dit: 'https://gtcardsditap6.nam.nsroot.net:1119/buscards/USBAO/login/flow.action',
                sit: 'https://gtcardsditap6.nam.nsroot.net:1119/buscards/USBAO/login/flow.action',
                uat1: 'https://test01.accountonline.com/buscards/USBAO/login/flow.action',
                uat2: 'https://test02.accountonline.com/buscards/USBAO/login/flow.action',
                uat3: 'https://test03.accountonline.com/buscards/USBAO/login/flow.action',
                prod: 'https://www.accountonline.com/buscards/USBAO/login/flow.action',
                perf: 'https://loadtest-aoaggr.nam.nsroot.net:7444/buscards/USBAO/login/flow.action',
                local: 'https://gtcardsditap6.nam.nsroot.net:1119/buscards/USBAO/login/flow.action'
            },
            BAORelaystateUrls: {
                dit: 'https://tymper.epsilon.com',
                sit: 'https://tymper.epsilon.com',
                uat1: 'https://tymper.epsilon.com',
                uat2: 'https://tymper.epsilon.com',
                uat3: 'https://tymper.epsilon.com',
                prod: 'https://www.thankyou.com',
                perf: 'https://tymper.epsilon.com',
                local: 'https://tymper.epsilon.com'
            },
            BAOSamlPostUrls: {
                dit: 'https://tymper.epsilon.com/gateway2.htm',
                sit: 'https://tymper.epsilon.com/gateway2.htm',
                uat1: 'https://tymper.epsilon.com/gateway2.htm',
                uat2: 'https://tymper.epsilon.com/gateway2.htm',
                uat3: 'https://tymper.epsilon.com/gateway2.htm',
                prod: 'https://www.thankyou.com/gateway2.htm',
                perf: 'https://tymper.epsilon.com/gateway2.htm',
                local: 'https://tymper.epsilon.com/gateway2.htm'
            },
            RelayStateUrls: "thankyou.com|www.thankyou.com|rewards.thankyou.com|www.rewards.thankyou.com|shopping.thankyou.com|www.shopping.thankyou.com|travel.thankyou.com|www.travel.thankyou.com|tyuat.epsilon.com|tyfut.bridge2rewards.com|citi-thankyou.staging.carteracommerce|qa.orxrdr.com|uat-ty.com|tymper.epsilon.com",
            SAMLPostUrls: "thankyou.com|www.thankyou.com|tyfut.epsilon.com|tymper.epsilon.com"
        };
    }
    getAppConstants() {
        return this.appConstants;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BAOLoginServiceConstants, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BAOLoginServiceConstants }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: BAOLoginServiceConstants, decorators: [{
            type: Injectable
        }] });

class NGALoginServiceConstants {
    constructor() {
        this.appConstants = {
            APIUrls: {
                loginSuccessRedirectUrl: '/parent-interstitial',
                liteDashboardUrl: '/parent-interstitial',
                errorRedirectUrl: '/nga-login/error',
                isE2eEnabled: true,
                enhancedForcedResetPasswordUrl: '/forgot-userid-pwd/update-userId',
                silentLoginURL: '/US/JSO/signon/PortalSignon.do',
                loginAPI: '/cbol/security/auth/passwordLogin',
                reqLocationChange: false,
                logoutAPI: '/cbol/security/auth/passwordLogout',
                welcomeScreenUrl: '/welcome',
                tandcUrl: '/tandc',
                ngaCommonDataCookieExpiryMinutes: '10',
                ngaSilentLoginErrorRedirectionUrl: '/US/ag/sign-off',
                welcomeScreenUrlGL: '/welcome',
                welcomeScreenUrlGLS: '/welcome',
                cinPinScreenUrl: '/welcome',
                ProfileRefreshAPI: '/cbol/security/customers/profileRefresh',
                partnerLoginAPI: '/digital/security/auth/partner/passwordLogin',
                lookUpAPICall: '/prelogin/digital/cbol/security/auth/password/userLookUp'
            }
        };
    }
    getAppConstants() {
        return this.appConstants;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginServiceConstants, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginServiceConstants }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginServiceConstants, decorators: [{
            type: Injectable
        }] });

class NGALoginUtilityService {
    constructor(_storageService, _httpService, _cookieService, _dataCollectorService, _unmanagedCookieService, constants, _appConfigService, router, _activatedRoute) {
        this._storageService = _storageService;
        this._httpService = _httpService;
        this._cookieService = _cookieService;
        this._dataCollectorService = _dataCollectorService;
        this._unmanagedCookieService = _unmanagedCookieService;
        this.constants = constants;
        this._appConfigService = _appConfigService;
        this.router = router;
        this._activatedRoute = _activatedRoute;
        this.signOffUrl = this.constants.getAppConstants()['APIUrls']['logoutAPI'];
    }
    // * When the session tokens are not set as HTTPOnly
    clearSessionsFallbackMode() {
        this._httpService.clearSessionTokens();
        const cookiesToDelete = ['Authorization', 'bizToken', 'isLoggedIn'];
        for (const cookieKey of cookiesToDelete) {
            Cookie.delete(cookieKey, '/');
            Cookie.delete(cookieKey, '/', '.citi.com');
        }
    }
    clearSessionCookies(skipBiztokenClear = false, isLogin = false) {
        console.log('Location: NGA-login-utility-service - clear biz, auth and ngacoexistence cookies');
        // Clear from app state
        // * CAP 847214 Remediation for fuip - do not clear biztoken if the flow is from retrieve user page
        // * Skip clearing / deleting session token for regular signon as it's handled on local block
        if (!skipBiztokenClear && !isLogin) {
            this._httpService.clearSessionTokens();
            this._httpService.deleteSessionTokens();
        }
        // ? No longer required as the citi_auth cookie is set to HTTPOnly  ...
        // ? ... and will be deleted via demotedCustomerSignOff
        // this._storageService.delete('citi_authorization', StorageService.COOKIE);
        // this._cookieService.deleteCookie('citi_authorization', '/', '.citi.com');
        this._storageService.delete('NGACoExistenceCookie', StorageService.COOKIE);
        this._storageService.delete('ssoFlagsList', StorageService.COOKIE);
        this._storageService.delete('ngaDeepdrop', StorageService.COOKIE);
        // Delete queryParams cookie everytime signonsubmit method is called
        this._storageService.delete('deepdropQueryParams', StorageService.COOKIE);
        this._cookieService.deleteCookie('NGACoExistenceCookie', '/', '.citi.com');
        this._cookieService.deleteCookie('ssoFlagsList', '/', '.citi.com');
        this._cookieService.deleteCookie('ngaDeepdrop', '/', '.citi.com');
        // Delete queryParams cookie everytime signonsubmit method is called
        this._cookieService.deleteCookie('deepdropQueryParams', '/', '.citi.com');
        //Delete invalid username cookie
        let tempUserNameCookie = this._storageService.get('username', StorageService.COOKIE);
        if (tempUserNameCookie === '' || !(tempUserNameCookie?.length > 0) || (tempUserNameCookie === '""') || tempUserNameCookie?.indexOf('""') > -1) {
            this._storageService.delete('username', StorageService.COOKIE);
            this._cookieService.deleteCookie('username', '/', '.citi.com');
        }
    }
    deleteDemotedCustomerSessionCall() {
        return this._httpService.delete(this.signOffUrl);
    }
    countOfUserNameStored() {
        const tempUserCookieContent = this._storageService.get('username', StorageService.COOKIE);
        const tempUserList = (tempUserCookieContent && tempUserCookieContent.length > 0) ? tempUserCookieContent.split('|') : '2';
        // -1 as the cookie value starts with 2|
        const strCountUsername = ((tempUserList.length) - 1).toString();
        return strCountUsername;
    }
    /**
    * @desc - parses a query string and returns a queryParamMap (key-value pair)
    **/
    getQueryParamMap(queryString) {
        const params = new URLSearchParams(queryString);
        const paramMap = {};
        params.forEach((value, key) => {
            paramMap[key] = value;
        });
        return paramMap;
    }
    deleteNgaLoginDataFromDataCollector() {
        this._dataCollectorService.removeDataCollector('ngaLoginCommonData');
        this._storageService.delete('ngaLoginCommonData', StorageService.COOKIE);
        this._cookieService.deleteCookie('ngaLoginCommonData', '/', '.citi.com');
    }
    dataAndCookieManagementRedirectionScenario(userid, remeberFlag) {
        console.log('Location: NGA-login-service.ts - deleting secondary login cookie');
        // Session Recovery Cookie
        this._unmanagedCookieService.set('SessionRecoveryCookie', userid, null, '/', '.citi.com', true);
        this.setUsernameCookie(userid, remeberFlag);
        this._storageService.delete('isSecondaryLogin', StorageService.COOKIE);
        this._cookieService.deleteCookie('isSecondaryLogin', '/', '.citi.com');
    }
    clearMigratedCookies() {
        // Delete MigratedSPF and MigratedMRC cookies
        console.log('Location: NGA-login-service.ts - deleting migrated cookies');
        this._storageService.delete('MigratedSPF', StorageService.COOKIE);
        this._storageService.delete('MigratedMRC', StorageService.COOKIE);
        Cookie.delete('MigratedSPF', '/', '.citi.com');
        Cookie.delete('MigratedMRC', '/', '.citi.com');
    }
    setUsernameCookie(userid, rememberFlag) {
        let user, flag = true;
        if (rememberFlag) {
            //If username cookie is not present then set it for the first time
            if (this._storageService.get('username', StorageService.COOKIE) == null) {
                user = '2|' + userid;
                this._unmanagedCookieService.set('username', user, 365, '/', '.citi.com', true);
            }
            else {
                /* If username cookie is present and entered userid is not matching with any one of the existing user ids in the cookie,
                append the new user id to it and update the cookie */
                //username cookie has empty string in it fix
                let tempUserNameCookie = this._storageService.get('username', StorageService.COOKIE);
                // TODO: Refactor - Too many nesting
                if (tempUserNameCookie === '' || !(tempUserNameCookie?.length > 0) || (tempUserNameCookie === '""') || tempUserNameCookie?.indexOf('""') > -1) {
                    this._storageService.delete('username', StorageService.COOKIE);
                    this._cookieService.deleteCookie('username', '/', '.citi.com');
                    user = '2|' + userid;
                    this._unmanagedCookieService.set('username', user, 365, '/', '.citi.com', true);
                }
                else {
                    // existing username cookie is valid
                    const currentUsernameCookie = this._storageService.get('username', StorageService.COOKIE);
                    const userList = this._storageService.get('username', StorageService.COOKIE).split('|');
                    for (let u in userList) {
                        console.log("Location: NGA-login-service.ts: users>>", userList[u]);
                        if (userList[u] === userid) {
                            flag = false;
                            this._unmanagedCookieService.set('username', currentUsernameCookie, 365, '/', '.citi.com', true);
                        }
                    }
                    if (flag) {
                        user = currentUsernameCookie + '|' + userid;
                        this._unmanagedCookieService.set('username', user, 365, '/', '.citi.com', true);
                    }
                }
            }
        }
    }
    /**
    * @desc - parses a @param url and then uses the appropriate navigation method
    **/
    navigate(url) {
        console.log("citi-navigate service url: ", url);
        if (url.includes("citi.com/")) {
            // Case 1: If redirectToNextRoute is a full URL containing "citi.com/"
            console.log("Case 1 navigate url >>", url);
            window.location.href = url;
        }
        else if (url.startsWith("/")) {
            // Case 2: If redirectToNextRoute starts with "/", use router navigation
            console.log("Case 2 navigate url >>", url);
            this.router.navigate([url], { relativeTo: this._activatedRoute });
        }
        else {
            // Case 3: If redirectToNextRoute is a relative path without "/"
            const constructedUrl = this._appConfigService.getcsrHostName() + "/US/ag/" + url;
            console.log("Case 3 navigate url >>", constructedUrl);
            window.location.href = constructedUrl;
        }
    }
    getEnvironmentSubDomain(envHostname, isSSO) {
        try {
            return new URL(envHostname).hostname.replace('www.', '').split('.')[0];
        }
        catch (error) {
            return isSSO ? 'uat2' : 'uat02'; // Default fallback
        }
    }
    updatePostSubmitUrl(url, envSubdomain, partnerSpId, domain) {
        let updatedUrl = url.replace(/uat+/g, envSubdomain);
        if (partnerSpId) {
            updatedUrl = updatedUrl.replace(/PartnerSpId=[^&]+/, `PartnerSpId=${partnerSpId}`);
        }
        if (domain) {
            updatedUrl = updatedUrl.replace(/test0[1-3]/g, domain);
        }
        return updatedUrl;
    }
    async triggerUserLookUpCall(userId, killSwitchFlag) {
        const deviceIdentifier = Cookie.get('preEmptiveCachingDeviceId');
        const endpointURL = this.constants.getAppConstants()['APIUrls']['lookUpAPICall'];
        const throttleEnabledFlag = Cookie.get('isPreEmptiveCachingEnabled');
        const cookieUserId = Cookie.get('preEmptiveCachingLookUp');
        if (!deviceIdentifier || throttleEnabledFlag !== userId || cookieUserId === userId || killSwitchFlag) {
            console.warn('User Look Up Call not Fired');
            return of(null);
        }
        await this._httpService.deleteSessions();
        const options = {
            headers: {
                'tenantId': 'LOOKUP_PASS'
            }
        };
        const payload = {
            userId,
            deviceIdentifier
        };
        try {
            const res = await firstValueFrom(this._httpService.post(endpointURL, payload, options));
            return res;
        }
        catch (err) {
            console.log("Lookup error", err);
            return false;
        }
    }
    async returnLoginSpeedKillSwitch() {
        let killSwitchFlagOn = true; // don't trigger the user look up call by default value is true
        return await this._httpService.get('/config', { headers: { channelId: 'CBOL' } }).toPromise().then((res) => {
            const rulesConfigRes = res['US_GCB_CBOL']['cbol_fuip'];
            console.log('Service Response Config >> ', rulesConfigRes);
            if (rulesConfigRes && rulesConfigRes.hasOwnProperty('loginSpeedKillSwitch')) {
                killSwitchFlagOn = rulesConfigRes.loginSpeedKillSwitch;
            }
            console.log('LoginSpeed Config >> ', killSwitchFlagOn);
            return killSwitchFlagOn;
        }).catch(() => {
            return true; // In case of error, default to true
        });
    }
    async detectIncognitoMode() {
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);
        const storageThreshold = isMobile ? 50 * 1024 * 1024 : 120 * 1024 * 1024;
        try {
            // Check storage quota
            if (navigator.storage?.estimate) {
                const { quota } = await navigator.storage.estimate();
                if (quota < storageThreshold) {
                    return true; // Incognito mode detected
                }
            }
            // Check FileSystem API (Chrome, Edge)
            if (window.webkitRequestFileSystem) {
                return await new Promise((resolve) => {
                    window.webkitRequestFileSystem(0, 1, // TEMPORARY = 0
                    () => resolve(false), // Normal mode
                    () => resolve(true) // Incognito mode
                    );
                });
            }
            // Check IndexedDB (Safari, Firefox, Edge)
            if (window.indexedDB) {
                return await new Promise((resolve) => {
                    const db = indexedDB.open("test");
                    db.onerror = () => resolve(true); // Incognito mode detected
                    db.onsuccess = () => resolve(false); // Normal mode
                });
            }
            // Check localStorage (Safari-specific behavior)
            try {
                if (window.localStorage) {
                    window.localStorage.setItem("test", 'test');
                    window.localStorage.removeItem("test");
                    return false; // Normal Mode
                }
            }
            catch (e) {
                if (e && (e.code === DOMException.QUOTA_EXCEEDED_ERR || e.code === DOMException.SECURITY_ERR)) {
                    return true; // Incognito mode detected
                }
            }
            // Safari Private Browsing fallback
            if (navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome")) {
                try {
                    window.openDatabase(null, null, null, null);
                }
                catch (e) {
                    return true; // Incognito mode detected
                }
            }
            return false; // Normal mode
        }
        catch (e) {
            return false; // Treat ambiguous result as normal mode
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginUtilityService, deps: [{ token: i1.StorageService }, { token: i1$1.HttpService }, { token: i1.CookieService }, { token: i1.DataCollectorService }, { token: i3.UnmanagedCookieService }, { token: NGALoginServiceConstants }, { token: i1.AppConfigService }, { token: i5.Router }, { token: i5.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginUtilityService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginUtilityService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.StorageService }, { type: i1$1.HttpService }, { type: i1.CookieService }, { type: i1.DataCollectorService }, { type: i3.UnmanagedCookieService }, { type: NGALoginServiceConstants }, { type: i1.AppConfigService }, { type: i5.Router }, { type: i5.ActivatedRoute }] });

class NGALoginValidationService {
    constructor(_httpService, mfaUiService, _cs, constants) {
        this._httpService = _httpService;
        this.mfaUiService = mfaUiService;
        this._cs = _cs;
        this.constants = constants;
        this.mfaUiServiceConfig = {
            ui: MfaUiService.MFA_UI_FULLPAGE,
            onSuccessValidation: MfaUiService.MFA_RETURN_CONTROL,
            exitRedirectionURL: this.constants.getAppConstants()['APIUrls']['ngaSilentLoginErrorRedirectionUrl']
        };
        this.loginAPI = this.constants.getAppConstants()['APIUrls']['loginAPI'];
        this.partnerloginAPI = this.constants.getAppConstants()['APIUrls']['partnerLoginAPI'];
        this.logoutAPI = this.constants.getAppConstants()['APIUrls']['logoutAPI'];
        this.ProfileRefreshAPI = this.constants.getAppConstants()['APIUrls']['ProfileRefreshAPI'];
    }
    userIdAndPwdValidation(partnerLoginReqBody, successCallBack, errorCallBack, customHeaders, tenantId) {
        let options = {};
        this.mfaUiServiceConfig.originFlow = 'login';
        // NGA Changes - Check Header later
        options = {
            headers: {
                'tenantId': 'DEFAULT',
                'channelId': 'CBOL',
                'appId': 'BROWSER',
                ...customHeaders
            },
            mfa: this.mfaUiServiceConfig
        };
        //citishop QR login changes
        if (tenantId === "citishop") {
            this.loginAPI = this.partnerloginAPI;
        }
        let observeResponseHeaders = true;
        if (customHeaders.tenantId === 'DEFAULT' || !customHeaders.tenantId) {
            options["headers"]["tenantId"] = Cookie$1.get("preEmptiveCachingLookUp") ? "AUTHENTICATION_PASS" : "DEFAULT";
        }
        // NGA Changes - Change endpoint
        const respObservable = this.mfaUiService.post(this.loginAPI, partnerLoginReqBody, options, successCallBack, errorCallBack, observeResponseHeaders);
        return respObservable;
    }
    ;
    initiateMfaSuccessCPSCall(partnerLoginAuthResumeReq, customHeaders, tenant, channelId) {
        let tenantId = 'DEFAULT';
        let channeld = 'CBOL';
        // TODO: Refactor - Generalize for partners
        if (tenant === 'amazon' || tenant === 'citishop' || tenant === 'flexpay') {
            tenantId = tenant;
        }
        // TODO: Refactor - Generalize for partners
        if (channelId === 'INTERNET') {
            channeld = channelId;
        }
        let options = {};
        // NGA Changes - Check Header later
        options = {
            headers: {
                'tenantId': tenantId,
                'channelId': channeld,
                'appId': 'BROWSER',
                ...customHeaders
            }
        };
        const cpsObservable = this._httpService.post(this.loginAPI, partnerLoginAuthResumeReq, options);
        return cpsObservable;
    }
    ;
    icmsCall() {
        return this._cs.getStaticBundle('cbol_nga_login_service');
    }
    profileRefreshAPI(refreshReqBody) {
        let options = {};
        options = {
            headers: {
                'tenantId': 'PROFILE-REFRESH'
            }
        };
        const cpsObservable = this._httpService.post(this.ProfileRefreshAPI, refreshReqBody, options);
        return cpsObservable;
    }
    partnerUserIdAndPwdValidation(partnerLoginReqBody, successCallBack, errorCallBack, customHeaders, tenantId, originFlow) {
        let options = {};
        this.mfaUiServiceConfig.originFlow = originFlow;
        // NGA Changes - Check Header later
        options = {
            headers: {
                'appId': 'BROWSER',
                ...customHeaders
            },
            mfa: this.mfaUiServiceConfig
        };
        // TODO: Refactor - Generalize for partners
        if (tenantId === "amazon" || tenantId === "citishop" || tenantId === "flexpay") {
            this.loginAPI = this.partnerloginAPI;
        }
        let observeResponseHeaders = true;
        // NGA Changes - Change endpoint
        const respObservable = this.mfaUiService.post(this.loginAPI, partnerLoginReqBody, options, successCallBack, errorCallBack, observeResponseHeaders);
        return respObservable;
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginValidationService, deps: [{ token: i1$1.HttpService }, { token: i2.MfaUiService }, { token: i1$1.ContentService }, { token: NGALoginServiceConstants }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginValidationService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginValidationService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.HttpService }, { type: i2.MfaUiService }, { type: i1$1.ContentService }, { type: NGALoginServiceConstants }] });

const TAGGING_CONSTANT = {
    "78cSignOnSuccess": {
        "action_type": "event",
        "app_hierarchy": "secure|signon|home|citi:sign on success",
        "event": "authentication_success",
        "link_name": "signon|home|citi:sign on success",
        "authenication_type": "web|password|non-ti|citi|l1.0",
        "test_id": "78 c Sign On Success"
    },
    "78_1e3CitiPartnerSignOnLandingQRCodeSignOnSuccess": {
        "action_type": "event",
        "app_hierarchy": "public|signon|citi partner|qr code sign on success",
        "event": "authentication_success",
        "authentication_type": "mobile|qr code|non-ti|citi|l3.0",
        "test_id": "78_1 e2 Citi Partner - Sign On Landing - QR Code Sign On Success"
    }
};

class TaggingService {
    triggerPageTagging(nonIcmsId, staticParam, options) {
        try {
            if (window) {
                let taggingDataLayer = window.taggingDataLayer;
                if (taggingDataLayer) {
                    const contentParam = options && options.dynamicContent ? { ...TAGGING_CONSTANT[staticParam], ...options.dynamicContent } : { ...TAGGING_CONSTANT[staticParam] };
                    staticParam ? taggingDataLayer.applicationData(nonIcmsId, contentParam) : taggingDataLayer.applicationData(TAGGING_CONSTANT[nonIcmsId]);
                }
            }
        }
        catch (e) {
            console.log('Error in PageTagging in tagging.service.ts in nga login service shared');
        }
    }
    triggerEventTagging(nonIcmsId, staticParam, options) {
        try {
            if (window) {
                let taggingDataLayer = window.taggingDataLayer;
                if (taggingDataLayer) {
                    const contentParam = options && options.dynamicContent ?
                        { ...TAGGING_CONSTANT[staticParam], ...options.dynamicContent } : { ...TAGGING_CONSTANT[staticParam] };
                    staticParam ? taggingDataLayer.updateEventData(nonIcmsId, contentParam) : taggingDataLayer.updateEventData(TAGGING_CONSTANT[nonIcmsId]);
                }
            }
        }
        catch (e) {
            console.log('Error in EventTagging in tagging.service.ts in nga login service shared');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TaggingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TaggingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TaggingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class NGALoginService {
    constructor(_appConfigService, _storageService, _loginValidationService, _cookieService, router, _activatedRoute, tmxService, _e2eService, _dataCollectorService, constants, baoConstants, _ngaLoginUtilityService, _unmanagedCookieService, taggingService, _httpService, featureDetectionService, mfaUtilityService
    //private config_service:CbolCoreConfigService
    ) {
        this._appConfigService = _appConfigService;
        this._storageService = _storageService;
        this._loginValidationService = _loginValidationService;
        this._cookieService = _cookieService;
        this.router = router;
        this._activatedRoute = _activatedRoute;
        this.tmxService = tmxService;
        this._e2eService = _e2eService;
        this._dataCollectorService = _dataCollectorService;
        this.constants = constants;
        this.baoConstants = baoConstants;
        this._ngaLoginUtilityService = _ngaLoginUtilityService;
        this._unmanagedCookieService = _unmanagedCookieService;
        this.taggingService = taggingService;
        this._httpService = _httpService;
        this.featureDetectionService = featureDetectionService;
        this.mfaUtilityService = mfaUtilityService;
        this.tenantId = 'DEFAULT';
        this.userId = '';
        this.pwd = '';
        this.e2eEnvId = this._appConfigService.getConfig('ngaLoginConfig').e2eEnvironmentId;
        this.nonE2eEnvId = this._appConfigService.getConfig('ngaLoginConfig').nonE2eEnvironmentId;
        this.ngaLoginCommonData = {};
        this.loginSuccessRedirectUrl = this.constants.getAppConstants()['APIUrls']['loginSuccessRedirectUrl'];
        this.enhancedForcedResetPasswordUrl = this.constants.getAppConstants()['APIUrls']['enhancedForcedResetPasswordUrl'];
        this.errorRedirectUrl = this.constants.getAppConstants()['APIUrls']['errorRedirectUrl'];
        this.reqLocationChange = this.constants.getAppConstants()['APIUrls']['reqLocationChange'];
        this.loginAPI = this.constants.getAppConstants()['APIUrls']['loginAPI'];
        this.logoutAPI = this.constants.getAppConstants()['APIUrls']['logoutAPI'];
        this.welcomeScreenUrl = this.constants.getAppConstants()['APIUrls']['welcomeScreenUrl'];
        this.welcomeScreenUrlGL = this.constants.getAppConstants()['APIUrls']['welcomeScreenUrlGL'];
        this.welcomeScreenUrlGLS = this.constants.getAppConstants()['APIUrls']['welcomeScreenUrlGLS'];
        this.cinPinScreenUrl = this.constants.getAppConstants()['APIUrls']['cinPinScreenUrl'];
        this.tandcUrl = this.constants.getAppConstants()['APIUrls']['tandcUrl'];
        this.isE2eEnabled = this.constants.getAppConstants()['APIUrls']['isE2eEnabled'];
        this.silentLoginURL = this.constants.getAppConstants()['APIUrls']['silentLoginURL'];
        this.ngaSilentLoginErrorRedirectionUrl = this.constants.getAppConstants()['APIUrls']['ngaSilentLoginErrorRedirectionUrl'];
        this.hostName = this._appConfigService.getcsrHostName();
        this.isJwtToken = true;
        this.baoNgaRedirection = '';
        this.jwtToken = '';
        this.cookieExpiryTime = new Date();
        this.ngaCommonDataCookieExpiryMinutes = Number(this.constants.getAppConstants()['APIUrls']['ngaCommonDataCookieExpiryMinutes']);
        this.baoLoginURL = '';
        this.baoTYRelaystateURL = '';
        this.baoTYSamlPostURL = '';
        this.baoTYRelaystateQueryValidUrl = '';
        this.baoTYSamlPostQueryValidUrl = '';
        this.ioBlackBox = '';
        this.devicePrint = '';
        this.ccsId = '';
        this.qrWebToken = '';
        this.isCitishopPartner = false;
        this.countOfUserNameStr = '';
        this.validateToShowSystemDownMsg = false;
        this.partnerAPI = false;
        this._tenantId = 'DEFAULT';
        this._channelId = 'CBOL';
        this.urlPathname = ['/', '/US/ag/bank/registration/confirmation', '/US/ag/user-registration/confirmation ']; // URL Array for 78c signon success tagging
        this.cbolConfigLoad = new EventEmitter();
        //For Linking Race condtion Issue
        //Remove upon chaning profileRefreshImplementation
        this.profileRefreshStatus = new EventEmitter();
        this.baoRelayStateQueryUrl = '';
        this.baoTravelPageQuery = '';
        this.baoLocaleQuery = '';
        this.isHomepageLogin = false;
        this.isQrLogin = false;
        this.fidoResponse = {
            userId: null,
            additionalInfo: {
                fidoEligibility: null,
                passKeyEligibility: null,
                userAgent: null,
                TMXDigitalApplicationType: null
            }
        };
        this.BiocatchResponse = {
            userId: null,
            additionalInfo: {
                bcsid: null
            }
        };
        this.passMan = {};
        this.loginOrigin = null;
        this.test = false;
        this.networkType = 'unknown';
        this.loginFlowSuccessHandler = (mfaSrvcDataWithHeaders) => {
            let mfaSrvcData = mfaSrvcDataWithHeaders.body ? mfaSrvcDataWithHeaders.body : mfaSrvcDataWithHeaders;
            // * Log FIDO response only if the device is eligible
            // if (this.fidoResponse.additionalInfo.fidoEligibility === true) {
            //   this.logFidoResponse();
            // }
            try {
                if (this.urlPathname.includes(window.location.pathname) && !this.isQrLogin) {
                    this.taggingService.triggerEventTagging('nonicms_content', '78cSignOnSuccess');
                    console.log("78csign on success tagging block in nga login service");
                }
                else if (this.isQrLogin && this._tenantId) {
                    this.taggingService.triggerEventTagging('nonicms_content', '78_1e3CitiPartnerSignOnLandingQRCodeSignOnSuccess', { dynamicContent: { 'form_type': this._tenantId } });
                    console.log("78_1e3 qr sign on success tagging block in nga login service");
                }
            }
            catch {
                console.log("error in 78csign on success tagging block in nga login service");
            }
            let homepageCdsFlagTurnOff = this._storageService.get('ssrhp2', StorageService.COOKIE);
            if (homepageCdsFlagTurnOff) {
                this._storageService.set('ssrhp2', 'true', StorageService.COOKIE);
            }
            //setting QR cookie
            if (Cookie.get('qrCodeLogin')) {
                Cookie.set('defaultQRCode', this.defaultQR, 90, '/', '.citi.com');
                console.log("Setting the default QR Code cookie", this.defaultQR);
            }
            else if (!(Cookie.get('qrCodeLogin')) && Cookie.get('defaultQRCode')) {
                Cookie.delete('defaultQRCode', '/', '.citi.com');
                console.log("Removing the default QR Code cookie");
            }
            this.ngaLoginCommonData = this._dataCollectorService.getDataForKey('ngaLoginCommonData');
            this.ngaLoginCommonData = (this.ngaLoginCommonData == null) ? JSON.parse(this._storageService.get('ngaLoginCommonData', StorageService.COOKIE)) : this.ngaLoginCommonData;
            this.authResumeToken = (this.ngaLoginCommonData && this.ngaLoginCommonData.authResumeToken) ? this.ngaLoginCommonData.authResumeToken : '';
            this.accountCompromised = (this.ngaLoginCommonData && this.ngaLoginCommonData.accountCompromised) ? this.ngaLoginCommonData.accountCompromised : '';
            if (mfaSrvcData) {
                let loginRequestEndTimer = new Date();
                this.timerDifference = loginRequestEndTimer - this.loginRequestStartTimer;
                let numberOfAccounts = mfaSrvcData.numberOfAccounts ? mfaSrvcData.numberOfAccounts : "";
                let customerPortfolio = mfaSrvcData.customerPortfolio ? mfaSrvcData.customerPortfolio : "";
                let ccsId = mfaSrvcData.ccsId ? mfaSrvcData.ccsId : "";
                let customerSegment = mfaSrvcData.customerSegment;
                let uuid = mfaSrvcDataWithHeaders.headers?.headers?.get("uuid")[0];
                let isEndToEndWebLoginSpeedCaptureEnabled = mfaSrvcData.endToEndWebLoginSpeedCaptureEnabled;
                this.callErrorLoggingApi(this.timerDifference, numberOfAccounts, customerPortfolio, ccsId, uuid, customerSegment, isEndToEndWebLoginSpeedCaptureEnabled);
            }
            // * Save query params and success URL for OMS deepdrop
            const queryParamMap = this.saveQueryParamsForRedirection();
            if (mfaSrvcData.toString().length !== 0 && mfaSrvcData.hasOwnProperty('ccsId') && mfaSrvcData.ccsId !== '') {
                this.performSuccessRedirection(mfaSrvcData);
            }
            else if (this.authResumeToken && this.authResumeToken.length > 0 && this.accountCompromised && this.accountCompromised.length > 0 && this.accountCompromised === 'B') {
                console.log('Location: NGA-login-service.ts, enhanced forced reset password case');
                this.mfaUtilityService.closeMfaOutlets();
                this.performInterdictionRedirection(mfaSrvcData, this.enhancedForcedResetPasswordUrl, queryParamMap);
            }
            else {
                if (mfaSrvcData.uuid && mfaSrvcData.uuid.length > 0 && !mfaSrvcData.hasOwnProperty('ccsId')) { // assuming 207 since we can't get the http status code.
                    // Delete nga login common data from common service
                    this._ngaLoginUtilityService.deleteNgaLoginDataFromDataCollector();
                    // We have to add logic for JWT Token response
                    this.jwtToken = mfaSrvcData.uuid;
                    this.isJwtToken = true;
                    if (mfaSrvcData.userId && mfaSrvcData.userId.length > 0) {
                        this.userId = mfaSrvcData.userId;
                    }
                    this._activatedRoute.queryParams.subscribe((queryParam) => {
                        if (queryParam['next_page']) {
                            this.nextPage = queryParam['next_page'];
                        }
                        if (queryParam['deepdrop']) {
                            this.deepdropFlag = queryParam['deepdrop'];
                        }
                        if (queryParam['loginscreenId']) {
                            this.loginscreenId = queryParam['loginscreenId'];
                        }
                        if (queryParam['targetAOApp']) {
                            this.targetAOApp = queryParam['targetAOApp'];
                        }
                        if (queryParam['next_ag_screen']) {
                            this.nextagScreen = '/US/ag/' + queryParam['next_ag_screen'];
                        }
                        if (queryParam['nextRoute']) {
                            this.nextRoute = '/US/ag/' + queryParam['nextRoute'];
                        }
                        if (queryParam['lastfour']) {
                            this.lastfour = queryParam['lastfour'];
                        }
                        if (queryParam['landing']) {
                            this.landing = queryParam['landing'];
                        }
                        if (queryParam['flow']) {
                            this.flow = queryParam['flow'];
                        }
                    });
                    this.messageBehaviourSubject(this.loginServiceMessageObject = { ngaLoginRedirectionFlow: true, ngaLoginResponse: mfaSrvcData });
                    this.createAndSubmitSilentLoginForm();
                }
                else if (mfaSrvcData.uauthToken && mfaSrvcData.uauthToken.length > 0 && !mfaSrvcData.hasOwnProperty('ccsId')) {
                    console.log("Location:NGA-login-service.ts- if uathToken -BAO Login form Post call ");
                    this.baoNgaRedirection = mfaSrvcData.uauthToken;
                    this.redirectToBaoLogin();
                }
                else if (this.authResumeToken === '' || this.authResumeToken === 'null' || isNil(this.authResumeToken)) {
                    console.log('Location: NGA-login-service.ts - Post MFA Success - AuthResumeToken not valid flow. errorurl is' + this.errorRedirectUrl);
                    // Delete nga login common data from common service
                    this.performErrorPageRedirection(mfaSrvcData, this.errorRedirectUrl);
                }
                else {
                    const partnerLoginAuthResumeReq = {
                        userId: this.userId,
                        authResumeToken: this.authResumeToken
                    };
                    // Delete nga login common data from common service
                    this._ngaLoginUtilityService.deleteNgaLoginDataFromDataCollector();
                    // NGA Changes - Need to check headers and logic change
                    const customHeaders = (this.isE2eEnabled) ?
                        {
                            'environmentId': this._tenantId === "citishop" ? "partnerLoginAuth" : this.e2eEnvId,
                            'countOfUserName': this._ngaLoginUtilityService.countOfUserNameStored(),
                            'featureId': this.featureId ? this.featureId : ''
                        } :
                        {
                            'environmentId': this.nonE2eEnvId,
                            'countOfUserName': this._ngaLoginUtilityService.countOfUserNameStored(),
                            'featureId': this.featureId ? this.featureId : ''
                        };
                    this._loginValidationService.initiateMfaSuccessCPSCall(partnerLoginAuthResumeReq, customHeaders, this._tenantId, this._channelId).subscribe((data) => {
                        if (data.toString().length !== 0 && data.hasOwnProperty('ccsId') && data.ccsId !== '') {
                            this.performSuccessRedirection(data);
                        }
                        else {
                            this.performErrorPageRedirection(data, this.errorRedirectUrl);
                        }
                    }, (errorObj) => {
                        const errResponse = errorObj.error || {};
                        if (errorObj.status === 403) {
                            if (errResponse.code === 'WELCOME_BACK') {
                                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                                this.performInterdictionRedirection(errorObj, this.welcomeScreenUrl, queryParamMap);
                            }
                            else if (errResponse.code === 'TERMS_AND_CONDITION') {
                                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                                this.performInterdictionRedirection(errorObj, this.tandcUrl, queryParamMap);
                            }
                            else if (errResponse.code === 'WELCOME_BACK_DPA_SKIP') {
                                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                                this.performInterdictionRedirection(errorObj, this.welcomeScreenUrlGLS, queryParamMap);
                            }
                            else if (errResponse.code === 'WELCOME_BACK_DPA') {
                                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                                this.performInterdictionRedirection(errorObj, this.welcomeScreenUrlGL, queryParamMap);
                            }
                            else if (errResponse.code === 'CINPIN') {
                                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex, errResponse.cinPinValidationToken);
                                this.performInterdictionRedirection(errorObj, this.cinPinScreenUrl);
                            }
                        }
                        else {
                            this.processLoginErrorResponse(errorObj);
                        }
                    });
                }
            }
            return EMPTY;
        };
        this.loginFlowErrorHandler = (error) => {
            this.isQrLogin = false;
            this.processLoginErrorResponse(error);
            return EMPTY;
        };
        // Intialize Beahviour subject
        this.loginServiceMessage = new BehaviorSubject(null);
        this.baoHostName = this.getEnvironment();
        this.previousLogin = (new Date()).getMilliseconds();
    }
    // * Exposing method for homepage message behaviour scenario
    setLoginServiceMessageObject(data = {}) {
        this.loginServiceMessage.next(data);
    }
    async returnOutage() {
        let outageBoolean;
        return await this._httpService.get('/config', { headers: { channelId: 'CBOL' } }).toPromise().then((res) => {
            const config = res['US_GCB_CBOL']['cbol_login_status'];
            console.log('PResponse Config >> ', config);
            outageBoolean = (config['fallbacks']['disableHomepageLogin'] !== undefined) ? config['fallbacks']['disableHomepageLogin'] : false;
            return outageBoolean;
        }).catch(() => {
            return false;
        });
    }
    /**
     * @name signOnSubmit
     * @desc - performs regular CBOL login request
     * @param userId
     * @param password
     * @param rememberUserIdFlag
     * @param renderer
     * @param ngaSilentLoginUseCase
     * @param queryParams
     * @param successRedirectUrl
     * @param featureId
     * @param loginMode
     * @param tenantId
     * @param skipBiztokenClear
     * @param passMan - to log whether password manager (auto-fill) was used in the input fields
     * @param isHomepageLogin
     * @param isLiteLogin
     * @returns
     */
    async signOnSubmit(userId = '', password = '', rememberUserIdFlag, renderer, ngaSilentLoginUseCase, queryParams, successRedirectUrl, featureId, loginMode, tenantId, skipBiztokenClear, passMan, isHomepageLogin, isLiteLogin) {
        // this flag is to check login is happening from homepage or any other login page. DRR-44683
        this.isHomepageLogin = isHomepageLogin;
        this.isLiteLogin = isLiteLogin;
        this.loginOrigin = isHomepageLogin ? 'homepage' : 'lite';
        if (passMan) {
            this.passMan = passMan;
        }
        // Remove white spaces trim()
        userId = userId.trim();
        password = password.trim();
        const regex = /^.{0,64}$/;
        if (!regex.test(password)) {
            this.test = true;
        }
        // IVR deep dropcheck the ivr disputes and send additional flag
        this.checkForIVRIntent();
        // Override successredirecturl if it has value
        this.loginSuccessRedirectUrl = successRedirectUrl || this.constants.getAppConstants()['APIUrls']['loginSuccessRedirectUrl'];
        let tmxSessionId = Cookie.get('tmx_sessionid') || '';
        if (tmxSessionId === '') {
            console.log("TMX session ID is Null, invoking TMX profile call");
            this.tmxService.getRequestParams();
        }
        ;
        // Clear Authorization and bizToken to get fresh bizToken generated before submit
        // * CAP 847214 Remediation for fuip - do not clear biztoken for enhanced visitors (FUIP)
        this._ngaLoginUtilityService.clearSessionCookies(skipBiztokenClear, true);
        // Intialize userid and password
        this.userId = userId;
        this.pwd = password;
        this.defaultQR = 'false';
        this.rememberFlag = rememberUserIdFlag;
        this.renderer = renderer;
        this.ngaSilentLoginUseCase = ngaSilentLoginUseCase;
        this.captureFidoResponse();
        this.captureBiocatchSessionId();
        // Store queryParams value
        if (queryParams != null && queryParams != '') {
            this.queryParams = queryParams;
        }
        //Passing loginMode value for bao multiple redirection.
        if (loginMode != null && loginMode != '') {
            this.loginMode = loginMode;
        }
        else {
            this.loginMode = 'MKTLOGIN';
        }
        // Fetch feature Id so that this can be passed as a header in login request
        if (featureId) {
            this.featureId = featureId;
        }
        if (tenantId != null && tenantId != '' && tenantId != undefined) {
            this.tenantId = tenantId;
        }
        // Blank user id or password
        if (this.userId.length === 0 || this.pwd.length === 0) {
            this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlowUnkownError: true, ngaLoginResponse: { 'error': 'userid or passowrd was blank' } });
            return;
        }
        // * If session tokens are not required to be cleared - current_usecases = ['FUIP Retrieve UserID Login']
        if (skipBiztokenClear) {
            this.e2eSignOn();
            return;
        }
        // * Wait till HTTPOnly Session tokens are cleared and then make the login call
        if (!Cookie.get("preEmptiveCachingLookUp") || (Cookie.get("preEmptiveCachingLookUp") !== userId)) {
            await this._httpService.deleteSessions();
        }
        // * proceed to clear session tokens and e2e eventid
        this._ngaLoginUtilityService.clearSessionsFallbackMode();
        this.e2eSignOn();
    }
    async processQrCodeLogin(ccsId, qrWebToken, renderer, ngaSilentLoginUseCase, queryParams, successRedirectUrl, featureId, skipBiztokenClear, tenantId, originFlow) {
        this.isQrLogin = true;
        if (tenantId) {
            this._tenantId = tenantId;
        }
        // capture biocatch session id for user.
        this.captureBiocatchSessionId();
        // Override successredirecturl if it has value
        this.loginSuccessRedirectUrl = successRedirectUrl || this.constants.getAppConstants()['APIUrls']['loginSuccessRedirectUrl'];
        // generate new TMX id if empty
        let tmxSessionId = Cookie.get('tmx_sessionid') || '';
        if (tmxSessionId === '') {
            console.log("TMX session ID is Null, invoking TMX profile call for ProcessQR signon");
            this.tmxService.getRequestParams();
        }
        ;
        this.defaultQR = 'true';
        // Clear Authorization and bizToken to get fresh bizToken generated before submit
        this._ngaLoginUtilityService.clearSessionCookies(skipBiztokenClear, true);
        // * Wait till HTTPOnly Session tokens are cleared and then make the login call
        if (this._tenantId !== 'citishop' || originFlow === 'fuip') {
            await this._httpService.deleteSessions();
        }
        // Intialize ccsId and qrWebToken
        this.ccsId = ccsId || '';
        this.qrWebToken = qrWebToken || '';
        this.rememberFlag = false;
        this.renderer = renderer;
        this.qrCodeLoginRequestBodyFlag = true;
        this.ngaSilentLoginUseCase = ngaSilentLoginUseCase;
        // Store queryParams value
        if (queryParams != null && queryParams != '') {
            this.queryParams = queryParams;
        }
        // Fetch feature Id so that this can be passed as a header in login request
        if (featureId) {
            this.featureId = featureId;
        }
        // Blank ccsId or qrWebToken
        if (this.ccsId === '' || this.ccsId === null) {
            console.log('Location: NGA-login-service - ccsId was blank');
            this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlowUnkownError: true, ngaLoginResponse: { 'error': 'ccsId was blank for QR flow' } });
            return;
        }
        if (this.qrWebToken === '' || this.qrWebToken === null) {
            console.log('Location: NGA-login-service - qrWebToken was blank');
            this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlowUnkownError: true, ngaLoginResponse: { 'error': 'qrWebToken was blank for QR flow' } });
            return;
        }
        // QR Code based NGA login - e2e sign on not needed here
        this.none2eSignOn();
    }
    /**
     * @name silentNGALogin
     * @description performs silent sign-on in pre-login flows
     **/
    silentNGALogin(userId = '', silentLoginToken, renderer, ngaSilentLoginUseCase, queryParams, successRedirectUrl, featureId) {
        // Remove white spaces trim()
        userId = userId.trim();
        // To check if any ivr intent is set from registration silent signon
        this.checkForIVRIntent();
        // Override successredirecturl if it has value
        this.loginSuccessRedirectUrl = successRedirectUrl || this.constants.getAppConstants()['APIUrls']['loginSuccessRedirectUrl'];
        // generate new TMX id if empty
        let tmxSessionId = Cookie.get('tmx_sessionid') || '';
        if (tmxSessionId === '') {
            console.log("TMX session ID is Null, invoking TMX profile call for Silent NGA signon");
            this.tmxService.getRequestParams();
        }
        ;
        // Intialize userid and password
        this.userId = userId;
        this.silentLoginToken = silentLoginToken;
        this.defaultQR = 'false';
        this.rememberFlag = false;
        this.renderer = renderer;
        this.ngaSilentLoginRequestBodyFlag = true;
        this.ngaSilentLoginUseCase = ngaSilentLoginUseCase;
        this.captureFidoResponse();
        this.captureBiocatchSessionId();
        // Store queryParams value
        if (queryParams != null && queryParams != '') {
            this.queryParams = queryParams + '&skipInterstitial=true';
        }
        // Fetch feature Id so that this can be passed as a header in login request
        if (featureId) {
            this.featureId = featureId;
        }
        // Blank user id
        if (this.userId.length === 0) {
            this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlowUnkownError: true, ngaLoginResponse: { 'error': 'userid or password was blank' } });
            return;
        }
        // NGA Changes - e2e sign on not needed here
        this.none2eSignOn();
    }
    loginResumeFlow(userId, authResumeToken, countOfUserName, flowType, deepdropQueryParams) {
        if (countOfUserName) {
            this.countOfUserNameStr = countOfUserName.toString();
        }
        let envId = this.isE2eEnabled ? this.e2eEnvId : this.nonE2eEnvId;
        const customHeaders = {
            'environmentId': this._tenantId === "citishop" ? "partnerLoginAuth" : envId,
            'countOfUserName': this.countOfUserNameStr,
            'featureId': this.featureId ? this.featureId : '',
            'tenantId': this._tenantId,
            'channelId': this._channelId
        };
        const requestBody = {
            userId: userId,
            authResumeToken: authResumeToken
        };
        this._loginValidationService.initiateMfaSuccessCPSCall(requestBody, customHeaders).subscribe(data => {
            console.log('Location: nga-login-service.ts - login resume call success', data);
            if (data.toString().length !== 0 && data.hasOwnProperty('ccsId') && data.ccsId !== '') {
                console.log('Location: tandc.component - ccsid found ');
                this.addDataForParentInterstitial(flowType);
                this.performSuccessRedirection(data, deepdropQueryParams);
            }
            else {
                this.signOffFlow({ 'error': 'login resume flow error' });
            }
            this._ngaLoginUtilityService.deleteNgaLoginDataFromDataCollector();
        }, (error) => {
            console.log('Location: nga-login-service - login resume failed', error);
            this.signOffFlow({ 'error': 'login resume flow error' });
        });
    }
    signOffFlow(data) {
        this._ngaLoginUtilityService.deleteDemotedCustomerSessionCall().subscribe();
        this.performErrorPageRedirection(data, this.errorRedirectUrl);
    }
    addDataForParentInterstitial(flowType) {
        if (!flowType)
            return;
        if (flowType === 'tandc') {
            Cookie.set('skipInterstitial', 'tandc', null, '/', '.citi.com');
        }
    }
    async e2eSignOn() {
        try {
            let partnerLoginReqBody;
            let pass = await this.encryptInputString(this.pwd, 'password');
            let privateBrowserMode = await this._ngaLoginUtilityService.detectIncognitoMode();
            console.log('Location: NGA-login-service.ts - privateBrowserMode: ' + privateBrowserMode);
            if (!pass) {
                throw new Error('Encryption returned empty');
            }
            partnerLoginReqBody = {
                userId: this.userId,
                password: pass,
                ...this.passMan,
                privateMode: privateBrowserMode
            };
            if (this.ivrFlag) { // To check if ivr intent is set from registration silent sigon
                partnerLoginReqBody['ivrLoginFlag'] = this.ivrFlag;
            }
            if (this.rememberFlag !== null && this.rememberFlag !== undefined) { // To check if remember flag is set
                partnerLoginReqBody['rememberUserIdFlag'] = this.rememberFlag;
            }
            if (Cookie.get("preEmptiveCachingLookUp") && Cookie.get("preEmptiveCachingDeviceId")) { // To send deviceIdentifier for login call
                partnerLoginReqBody['deviceIdentifier'] = Cookie.get("preEmptiveCachingDeviceId");
            }
            const customHeaders = {
                'environmentId': this.e2eEnvId,
                'countOfUserName': this._ngaLoginUtilityService.countOfUserNameStored(),
                'featureId': this.featureId ? this.featureId : '',
                'tenantId': this.tenantId
            };
            this.loginRequestStartTimer = new Date();
            this._loginValidationService.userIdAndPwdValidation(partnerLoginReqBody, this.loginFlowSuccessHandler, this.loginFlowErrorHandler, customHeaders);
        }
        catch (error) {
            console.log('Location: NGA-login-service.ts - e2e failed, trying login without e2e ' + JSON.stringify(error.message));
            let errorObj = { e2eEncriptionError: true, ngaLoginNoRedirectionFlow500Error: true, ngaLoginResponse: error };
            this.setLoginServiceMessageObject(errorObj);
            return EMPTY;
        }
    }
    none2eSignOn() {
        let partnerLoginReqBody;
        // Take care of silent login scenario
        if (!this.ngaSilentLoginRequestBodyFlag) {
            partnerLoginReqBody = {
                userId: this.userId,
                password: this.pwd,
                ...this.passMan
            };
        }
        else {
            partnerLoginReqBody = {
                userId: this.userId,
                authResumeToken: this.silentLoginToken
            };
        }
        if (this.ivrFlag) { // To check if ivr intent is set from registration silent sigon
            partnerLoginReqBody['ivrLoginFlag'] = this.ivrFlag;
        }
        //add ccsId and qrWebToken to request body for QR code login
        if (this.qrCodeLoginRequestBodyFlag) {
            partnerLoginReqBody = {
                userId: this.userId,
                ccsId: this.ccsId,
                qrWebToken: this.qrWebToken
            };
        }
        if (this._tenantId === "citishop") {
            this.e2eEnvId = "partnerLoginAuth";
            this.isCitishopPartner = true;
        }
        const customHeaders = (this.isCitishopPartner) ?
            {
                'environmentId': (this.qrCodeLoginRequestBodyFlag || this.ngaSilentLoginRequestBodyFlag) ? this.e2eEnvId : this.nonE2eEnvId,
                'countOfUserName': this._ngaLoginUtilityService.countOfUserNameStored(),
                'featureId': this.featureId ? this.featureId : '',
                'tenantId': this._tenantId
            } :
            {
                'environmentId': (this.qrCodeLoginRequestBodyFlag || this.ngaSilentLoginRequestBodyFlag) ? this.e2eEnvId : this.nonE2eEnvId,
                'countOfUserName': this._ngaLoginUtilityService.countOfUserNameStored(),
                'featureId': this.featureId ? this.featureId : ''
            };
        //allow BAU login in same page if QR code login fails
        this.qrCodeLoginRequestBodyFlag = false;
        this.ngaSilentLoginRequestBodyFlag = false;
        this._loginValidationService.userIdAndPwdValidation(partnerLoginReqBody, this.loginFlowSuccessHandler, this.loginFlowErrorHandler, customHeaders, this._tenantId);
    }
    async encryptInputString(rawValue, valueType) {
        // TODO: Make it 100% E2E
        if (this.isE2eEnabled) {
            const enVal = await this._e2eService.encryptData(rawValue, valueType);
            return enVal;
        }
        else {
            return rawValue;
        }
    }
    /**
     * @name captureBiocatchSessionId
     * @desc - logs if the user session doesnt have biocatch session id
     */
    captureBiocatchSessionId() {
        if (!Cookie.get('bcsid')) {
            this.BiocatchResponse.userId = this.userId;
            this.BiocatchResponse.additionalInfo.bcsid = Cookie.get('bcsid');
            // * Log Biocatch response to errorLogging API (for now)
            this._httpService.post('/prelogin/digital/reporting/userInterface/errorLogging', this.BiocatchResponse).subscribe();
        }
    }
    /**
     * @name captureFidoResponse
     * @desc - logs if the device has FIDO capabilities
     */
    captureFidoResponse() {
        this.fidoResponse.userId = this.userId;
        try {
            PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then(res => {
                this.fidoResponse.additionalInfo.fidoEligibility = res;
                this.fidoResponse.additionalInfo.userAgent = this.getUserAgentBrowserName();
                console.log("FIDO UserAgent", this.fidoResponse.additionalInfo.userAgent);
                console.log("FIDO BrowserName", this.getUserAgentBrowserName());
                this.fidoResponse.additionalInfo.TMXDigitalApplicationType = this.applicationType();
                console.log("FIDO TMXDigitalApplicationType", this.fidoResponse.additionalInfo.TMXDigitalApplicationType);
                // @ts-ignore - ignoring as TypeScript's PublicKeyCredential interface is limited
                PublicKeyCredential.isConditionalMediationAvailable?.()
                    .then((res) => this.fidoResponse.additionalInfo.passKeyEligibility = res);
            });
        }
        catch (error) {
            console.log("FIDO Error >> ", error);
        }
    }
    applicationType() {
        if (this.featureDetectionService.isMobile()) {
            return 'MOBILE_BROWSER';
        }
        else {
            return 'PC_BROWSER';
        }
    }
    /**
      * @name captureUserAgentBrowser
      * @desc - logs the browser value
      */
    getUserAgentBrowserName() {
        let userAgent = window.navigator.userAgent;
        if (!userAgent) {
            console.log('User agent not available');
            return 'unknown';
        }
        let userAgentData = userAgent.toLowerCase();
        var browserName = '';
        let chromeAgent = userAgentData.indexOf("chrome") > -1;
        let iExplorerAgent = userAgentData.indexOf("msie") > -1 || userAgentData.indexOf("trident") > -1;
        let firefoxAgent = userAgentData.indexOf("firefox") > -1;
        let safariAgent = userAgentData.indexOf("safari") > -1;
        let edgeAgent = userAgentData.indexOf("edg") > -1;
        if (chromeAgent && safariAgent) {
            safariAgent = false;
        }
        if ((chromeAgent && safariAgent && edgeAgent)) {
            safariAgent = false;
            chromeAgent = false;
        }
        let operaAgent = userAgentData.indexOf("op") > -1;
        if (chromeAgent && operaAgent) {
            chromeAgent = false;
        }
        if (safariAgent) {
            browserName = 'Safari';
        }
        else if (chromeAgent) {
            browserName = 'Chrome';
        }
        else if (iExplorerAgent) {
            browserName = 'Internet Explorer';
        }
        else if (operaAgent) {
            browserName = 'Opera';
        }
        else if (firefoxAgent) {
            browserName = 'Firefox';
        }
        else if (edgeAgent) {
            browserName = 'Edge';
        }
        else {
            browserName = userAgentData;
        }
        console.log('agent', browserName);
        return browserName;
    }
    logFidoResponse() {
        // * Log fido response to errorLogging API (for now)
        this._httpService.post('/prelogin/digital/reporting/userInterface/errorLogging', this.fidoResponse).subscribe();
    }
    processLoginErrorResponse(error) {
        //If shape blocked then should have invalid response. Check for that and reload
        if (!error || !error.error || (error.error && error.error.text && error.error.text.indexOf('html') > -1)) {
            window.location.reload();
            return;
        }
        // Logic to determine if customer ccsid is throttled for new cds password guidelines experience
        Cookie.delete("passwordHistoryCheckRequired");
        if (error.error['passwordHistoryCheckRequired'] && error.error['passwordHistoryCheckRequired'] === true) {
            this._cookieService.setCookie({
                name: "passwordHistoryCheckRequired",
                value: "true",
                path: "/",
                expires: 0,
                domain: "citi.com"
            });
        }
        else {
            this._cookieService.setCookie({
                name: "passwordHistoryCheckRequired",
                value: "false",
                path: "/",
                expires: 0,
                domain: "citi.com"
            });
        }
        console.log("flag check", Cookie.get("passwordHistoryCheckRequired"));
        // * Save query params and success URL for OMS deepdrop
        const queryParamMap = this.saveQueryParamsForRedirection();
        const errResponse = error.error || {};
        if (error.status === 400) {
            console.log('Location: NGA-login-service.ts - Error code 400, invalid login count is', error.error.failureCount);
            this.deleteQrCodeCookie();
            if (error.error.failureCount > 6) {
                // Forgot user id password flow
                this._ngaLoginUtilityService.deleteNgaLoginDataFromDataCollector();
                console.log("ngaLoginNoRedirectionFlow400Error");
                this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlow400Error: true, ngaLoginResponse: error, invalidLoginAttemptExceed400Error: true, failureCount: error.error.failureCount });
            }
            else {
                this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlow400Error: true, ngaLoginResponse: error, invalidLoginAttemptExceed400Error: false, failureCount: error.error.failureCount });
            }
        }
        else if (error.status === 403) {
            if (errResponse.code === 'WELCOME_BACK') {
                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                this.performInterdictionRedirection(error, this.welcomeScreenUrl, queryParamMap);
            }
            else if (errResponse.code === 'WELCOME_BACK_DPA_SKIP') {
                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                this.performInterdictionRedirection(error, this.welcomeScreenUrlGLS, queryParamMap);
            }
            else if (errResponse.code === 'WELCOME_BACK_DPA') {
                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                this.performInterdictionRedirection(error, this.welcomeScreenUrlGL, queryParamMap);
            }
            else if (errResponse.code === 'TERMS_AND_CONDITION') {
                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                this.performInterdictionRedirection(error, this.tandcUrl, queryParamMap);
            }
            else if (errResponse.code === 'CINPIN') {
                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex, errResponse.cinPinValidationToken);
                this.performInterdictionRedirection(error, this.cinPinScreenUrl);
            }
            else if (errResponse.code === 'mfaRequired' && ((errResponse.moreInfo == null) || (errResponse.moreInfo && errResponse.moreInfo.length === 0))
                && ((errResponse.moreInfoCollect == null) || Object.keys(errResponse.moreInfoCollect).length === 0)) {
                let homepageCdsFlag = this._storageService.get('ssrhp2', StorageService.COOKIE);
                if (homepageCdsFlag) {
                    this._storageService.set('ssrhp2', 'false', StorageService.COOKIE);
                }
                this.performErrorPageRedirection(error, this.errorRedirectUrl);
            }
            else {
                // Place to handle anything during MFA flow.
                this.addDatatoDataCollector(errResponse.authResumeToken, errResponse.accountCompromised, errResponse.complianceFlowResumeToken, errResponse.lastFourDigitAccountNumber, errResponse.isAmex);
                this.messageBehaviourSubject(this.loginServiceMessageObject = { ngaLoginRedirectionFlow: true, ngaLoginResponse: error });
            }
        }
        else if (error.status === 423) {
            this.messageBehaviourSubject(this.loginServiceMessageObject = { ngaLoginRedirectionFlow: true, ngaLoginResponse: error, invalidLoginAttemptExceed423Error: true });
            // Place to handle Account Locked flow.
            // NGA Login Changes - How to handle account lock flow
            this._ngaLoginUtilityService.deleteNgaLoginDataFromDataCollector();
        }
        else if (error.status === 424) {
            //display system shut down message
            this.validateToShowSystemDownMsg = true;
            this.messageBehaviourSubject(this.loginServiceMessageObject = { ngaLoginRedirectionFlow: true, ngaLoginResponse: { status: error.status } });
        }
        else if (error.status === 500) {
            this.deleteQrCodeCookie();
            this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlow500Error: true, ngaLoginResponse: error });
            // Place to handle Server Error flow.
            if (errResponse && errResponse.code === 'serverUnavailable') {
                // TODO: Implement error messaging
            }
            else {
                // TODO: Implement error messaging
            }
        }
        else if (error.status === 417) {
            this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlow417Error: true, ngaLoginResponse: error });
        }
        else {
            this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlowUnkownError: true, ngaLoginResponse: error });
        }
        return catchError(error);
    }
    // Delete qrCodeLogin Cookie for failed logins
    deleteQrCodeCookie() {
        if (Cookie.get('qrCodeLogin')) {
            Cookie.delete('qrCodeLogin', '/', '.citi.com');
            console.log("Removing the qrCodeLogin cookie");
        }
    }
    saveQueryParamsForRedirection() {
        const queryParamMap = this._ngaLoginUtilityService.getQueryParamMap(this.queryParams);
        queryParamMap['successRedirectUrl'] = this.loginSuccessRedirectUrl;
        queryParamMap['loginOrigin'] = this.loginOrigin;
        queryParamMap['partnerApi'] = String(this.partnerAPI);
        queryParamMap['tenantId'] = this._tenantId;
        queryParamMap['channelId'] = this._channelId;
        return queryParamMap;
    }
    performSuccessRedirection(loginResponse, deepdropQueryParams) {
        console.log("deepdrop params", deepdropQueryParams);
        // Delete nga login common data from common service
        this._ngaLoginUtilityService.deleteNgaLoginDataFromDataCollector();
        this._cookieService.deleteCookie('ivrintent', '/', '.citi.com');
        //  Add session cookie for succesful nga login
        this._unmanagedCookieService.set('MigratedMRC', 'true', 365, '/', '.citi.com', true);
        //  Set login csutomer type cookie
        if (loginResponse && loginResponse.customerType && loginResponse.customerType.length > 0) {
            this._unmanagedCookieService.set('loginCustomerType', loginResponse.customerType, null, '/', '.citi.com', true);
        }
        // when userid value is null it will read from response body userName value for QRlogin and if not then it will work as it is for passwordLogin
        if (!this.userId) {
            if (loginResponse && ((loginResponse.userId && loginResponse.userId.length > 0) || (loginResponse.userName && loginResponse.userName.length > 0))) {
                this.userId = loginResponse.userId ? loginResponse.userId : loginResponse.userName;
            }
        }
        this._ngaLoginUtilityService.dataAndCookieManagementRedirectionScenario(this.userId, this.rememberFlag);
        //* Set deepdrop cookie for deepdrop links (check for queryParams)
        try {
            if (window.location.pathname.indexOf('login') > -1 && window.location.search) {
                this._unmanagedCookieService.set('ngaDeepdrop', 'true', null, '/', '.citi.com', true);
            }
        }
        catch (err) {
            console.error("Exception Caught > ", err);
        }
        // Add logic for deepdrop queryParams
        if (deepdropQueryParams && deepdropQueryParams.length > 0) {
            console.log("deepdrop>>", this.loginSuccessRedirectUrl, deepdropQueryParams);
            this.loginSuccessRedirectUrl = this.loginSuccessRedirectUrl + "?" + deepdropQueryParams;
        }
        // Add logic for queryParams store in query params
        if (this.queryParams && this.queryParams.length > 0) {
            this.loginSuccessRedirectUrl = this.loginSuccessRedirectUrl + "?" + this.queryParams;
        }
        //  Emit value to behaviour subject
        this.messageBehaviourSubject(this.loginServiceMessageObject = { ngaLoginRedirectionFlow: true, ngaLoginResponse: loginResponse });
        // * Redirect to lite dashboard (drop the nextRoute param) if user has imited access to the features
        if (loginResponse.retailLimitedAccessLogin === true) {
            this.loginSuccessRedirectUrl = this.constants.getAppConstants()['APIUrls']['liteDashboardUrl'];
        }
        window.location.href = this._appConfigService.getcsrHostName() + '/US/ag' + this.loginSuccessRedirectUrl;
    }
    performInterdictionRedirection(loginResponse, url, queryParams) {
        // Add queryParams cookie for interdiction scenarios
        this._unmanagedCookieService.set('deepdropQueryParams', this.queryParams, this.cookieExpiryTime, '/', '.citi.com');
        this._ngaLoginUtilityService.dataAndCookieManagementRedirectionScenario(this.userId, this.rememberFlag);
        // Emit behaviour subject
        this.messageBehaviourSubject(this.loginServiceMessageObject = { ngaLoginRedirectionFlow: true, ngaLoginResponse: loginResponse });
        if (loginResponse.error.code === 'WELCOME_BACK_DPA_SKIP') {
            this.router.navigate([url], { queryParams: { ct: '1' } });
            return;
        }
        if (loginResponse.error.code === 'WELCOME_BACK_DPA') {
            this.router.navigate([url], { queryParams: { ct: '0' } });
            return;
        }
        if (loginResponse.error.code === 'CINPIN') {
            this.router.navigate([url], { queryParams: { cinpin: true } });
            return;
        }
        if (loginResponse.error.code === 'WELCOME_BACK' && loginResponse.error.cvvOnlyWelcomeBack === true) {
            this.router.navigate([url, { outlets: { mfaContent: null, mfaConfirm: null } }], { queryParams: { disableSW: true } });
            return;
        }
        if (queryParams) {
            this.router.navigate([url], { queryParams: queryParams });
            return;
        }
        this.router.navigate([url]);
    }
    performErrorPageRedirection(loginResponse, url) {
        this._ngaLoginUtilityService.deleteNgaLoginDataFromDataCollector();
        this._ngaLoginUtilityService.clearSessionCookies();
        this.messageBehaviourSubject(this.loginServiceMessageObject = { ngaLoginRedirectionFlow: true, ngaLoginResponse: loginResponse });
        this.router.navigate([url]);
    }
    messageBehaviourSubject(value) {
        console.log('Location: NGA-login-service.ts - messagebeahviour subject method');
        this.loginServiceMessage.next(value);
    }
    /**
     * @name getNgLoginObservable
     * @desc returns the current login message subject as an observable
     */
    getNgaLoginObservable() {
        return this.loginServiceMessage.asObservable();
    }
    addDatatoDataCollector(authResumeToken, accountCompromised, complianceFlowResumeToken, accountNumberLast4, isAmex, cinPinValidationToken) {
        const commonData = {
            'userId': this.userId,
            'authResumeToken': authResumeToken,
            'environmentId': (this.isE2eEnabled) ? this.e2eEnvId : this.nonE2eEnvId,
            'isE2eEnabled': this.isE2eEnabled,
            'reqLocationChange': this.reqLocationChange,
            'loginSuccessRedirectUrl': this.loginSuccessRedirectUrl,
            'loginErrorRedirectUrl': this.errorRedirectUrl,
            'accountCompromised': accountCompromised ? accountCompromised : null,
            'countOfUserName': this._ngaLoginUtilityService.countOfUserNameStored(),
            'complianceFlowResumeToken': complianceFlowResumeToken,
            'lastFourDigitAccountNumber': accountNumberLast4,
            'isAmex': isAmex,
            'cinPinValidationToken': cinPinValidationToken
        };
        const cookieCommonData = {
            'userId': this.userId,
            'environmentId': (this.isE2eEnabled) ? this.e2eEnvId : this.nonE2eEnvId,
            'isE2eEnabled': this.isE2eEnabled,
            'reqLocationChange': this.reqLocationChange,
            'loginSuccessRedirectUrl': this.loginSuccessRedirectUrl,
            'loginErrorRedirectUrl': this.errorRedirectUrl,
            'accountCompromised': accountCompromised ? accountCompromised : null,
            'countOfUserName': this._ngaLoginUtilityService.countOfUserNameStored(),
            'lastFourDigitAccountNumber': accountNumberLast4,
            'isAmex': isAmex,
            'cinPinValidationToken': cinPinValidationToken
        };
        this.cookieExpiryTime.setMinutes(this.cookieExpiryTime.getMinutes() + this.ngaCommonDataCookieExpiryMinutes);
        this._dataCollectorService.addDataCollector({ 'ngaLoginCommonData': commonData });
        this._unmanagedCookieService.set('ngaLoginCommonData', JSON.stringify(cookieCommonData), this.cookieExpiryTime, '/', '.citi.com', true);
    }
    createAndSubmitSilentLoginForm() {
        let silentLoginForm = this.renderer.createElement('FORM');
        this.renderer.appendChild(document.body, silentLoginForm);
        silentLoginForm.style.display = "none";
        silentLoginForm.name = 'silentLoginForm';
        silentLoginForm.method = 'POST';
        silentLoginForm.action = this.hostName + this.silentLoginURL;
        let userid = this.renderer.createElement('INPUT');
        userid.type = 'HIDDEN';
        userid.name = 'userId';
        userid.value = this.userId;
        silentLoginForm.appendChild(userid);
        let jwtToken = this.renderer.createElement('INPUT');
        jwtToken.type = 'HIDDEN';
        jwtToken.name = 'plToken';
        jwtToken.value = this.jwtToken;
        silentLoginForm.appendChild(jwtToken);
        if (this.nextPage) {
            let nextPage = this.renderer.createElement('INPUT');
            nextPage.type = 'HIDDEN';
            nextPage.name = 'next_page';
            nextPage.value = this.nextPage;
            silentLoginForm.appendChild(nextPage);
        }
        if (this.deepdropFlag) {
            let deepdrop = this.renderer.createElement('INPUT');
            deepdrop.type = 'HIDDEN';
            deepdrop.name = 'deepdrop';
            deepdrop.value = this.deepdropFlag;
            silentLoginForm.appendChild(deepdrop);
        }
        if (this.loginscreenId) {
            let loginscreenId = this.renderer.createElement('INPUT');
            loginscreenId.type = 'HIDDEN';
            loginscreenId.name = 'loginscreenId';
            loginscreenId.value = this.loginscreenId;
            silentLoginForm.appendChild(loginscreenId);
        }
        if (this.targetAOApp) {
            let targetAOApp = this.renderer.createElement('INPUT');
            targetAOApp.type = 'HIDDEN';
            targetAOApp.name = 'targetAOApp';
            targetAOApp.value = this.targetAOApp;
            silentLoginForm.appendChild(targetAOApp);
        }
        if (this.nextagScreen) {
            let nextagScreen = this.renderer.createElement('INPUT');
            nextagScreen.type = 'HIDDEN';
            nextagScreen.name = 'next_ag_screen';
            nextagScreen.value = this.nextagScreen;
            silentLoginForm.appendChild(nextagScreen);
        }
        if (this.nextRoute) {
            let nextRoute = this.renderer.createElement('INPUT');
            nextRoute.type = 'HIDDEN';
            nextRoute.name = 'next_ag_screen';
            nextRoute.value = this.nextRoute;
            silentLoginForm.appendChild(nextRoute);
        }
        if (this.lastfour) {
            let lastfour = this.renderer.createElement('INPUT');
            lastfour.type = 'HIDDEN';
            lastfour.name = 'lastfour';
            lastfour.value = this.lastfour;
            silentLoginForm.appendChild(lastfour);
        }
        if (this.landing) {
            let landing = this.renderer.createElement('INPUT');
            landing.type = 'HIDDEN';
            landing.name = 'landing';
            landing.value = this.landing;
            silentLoginForm.appendChild(landing);
        }
        if (this.flow) {
            let flow = this.renderer.createElement('INPUT');
            flow.type = 'HIDDEN';
            flow.name = 'flow';
            flow.value = this.flow;
            silentLoginForm.appendChild(flow);
        }
        this.silentLoginSubmitForm(silentLoginForm);
    }
    silentLoginSubmitForm(form) {
        this._ngaLoginUtilityService.clearMigratedCookies();
        // Submit the silent login form
        form.submit();
    }
    getEnvironment() {
        let browserUrl = this._appConfigService.getcsrHostName();
        if (browserUrl.indexOf("dit") != -1) {
            return "dit";
        }
        else if (browserUrl.indexOf("sit") != -1) {
            return "sit";
        }
        else if (browserUrl.indexOf("uat1") != -1 || browserUrl.indexOf("uat01") != -1) {
            return "uat1";
        }
        else if (browserUrl.indexOf("uat2") != -1 || browserUrl.indexOf("uat02") != -1) {
            return "uat2";
        }
        else if (browserUrl.indexOf("uat3") != -1 || browserUrl.indexOf("uat03") != -1) {
            return "uat3";
        }
        else if (browserUrl.indexOf("webqa") != -1) {
            return "perf";
        }
        else if (browserUrl.match("online.citi.com") || browserUrl.match("citi.com")) {
            return "prod";
        }
        else {
            return "local";
        }
    }
    redirectToBaoLogin() {
        this._loginValidationService.icmsCall().subscribe({
            next: (res) => {
                if (res) {
                    this.baoLoginURL = JSON.parse(res['copy$$bao_login_urls']['BAOUrls'])[this.baoHostName];
                    this.baoTYRelaystateURL = JSON.parse(res['copy$$bao_login_urls']['BAORelaystateUrls'])[this.baoHostName];
                    this.baoTYSamlPostURL = JSON.parse(res['copy$$bao_login_urls']['BAOSamlPostUrls'])[this.baoHostName];
                    this.baoTYRelaystateQueryValidUrl = res['copy$$bao_login_urls']['RelayStateUrls'];
                    this.baoTYSamlPostQueryValidUrl = res['copy$$bao_login_urls']['SAMLPostUrls'];
                }
                else {
                    console.log('error in ICMS service, use deafult bao icms data');
                    this.baoLoginURL = this.baoConstants.getAppConstants['BAOUrls'][this.baoHostName];
                    this.baoTYRelaystateURL = this.baoConstants.getAppConstants['BAORelaystateUrls'][this.baoHostName];
                    this.baoTYSamlPostURL = this.baoConstants.getAppConstants['BAOSamlPostUrls'][this.baoHostName];
                    this.baoTYRelaystateQueryValidUrl = this.baoConstants.getAppConstants['RelayStateUrls'];
                    this.baoTYSamlPostQueryValidUrl = this.baoConstants.getAppConstants['SAMLPostUrls'];
                }
                this.constructForm();
            },
            error: (err) => {
                this.baoLoginURL = this.baoConstants.getAppConstants['BAOUrls'][this.baoHostName];
                this.baoTYRelaystateURL = this.baoConstants.getAppConstants['BAORelaystateUrls'][this.baoHostName];
                this.baoTYSamlPostURL = this.baoConstants.getAppConstants['BAOSamlPostUrls'][this.baoHostName];
                this.baoTYRelaystateQueryValidUrl = this.baoConstants.getAppConstants['RelayStateUrls'];
                this.baoTYSamlPostQueryValidUrl = this.baoConstants.getAppConstants['SAMLPostUrls'];
                this.constructForm();
            }
        });
    }
    constructForm() {
        let baoLoginForm = this.renderer.createElement('Form');
        this.renderer.appendChild(document.body, baoLoginForm);
        baoLoginForm.style.display = 'none';
        baoLoginForm.name = 'baoLoginForm';
        baoLoginForm.method = 'POST';
        baoLoginForm.action = this.baoLoginURL;
        let formType = this.renderer.createElement('INPUT');
        formType.type = 'HIDDEN';
        formType.name = 'formType';
        formType.value = this._activatedRoute.snapshot.queryParamMap.get('bformType') || '';
        baoLoginForm.appendChild(formType);
        let expBase = this.renderer.createElement('INPUT');
        expBase.type = 'HIDDEN';
        expBase.name = 'expBase';
        expBase.value = this._activatedRoute.snapshot.queryParamMap.get('bexpBase') || '';
        baoLoginForm.appendChild(expBase);
        let loginMode = this.renderer.createElement('INPUT');
        loginMode.type = 'HIDDEN';
        loginMode.name = 'LOGIN_MODE';
        loginMode.value = this.loginMode;
        baoLoginForm.appendChild(loginMode);
        if (this.loginMode == 'tyLogin') {
            let baoRelayStateQueryUrl = this._activatedRoute.snapshot.queryParamMap.get('relayState');
            let baoSamlPostQueryUrl = this._activatedRoute.snapshot.queryParamMap.get('SAMLPostURL');
            if (baoRelayStateQueryUrl && this.baoTYRelaystateQueryValidUrl.includes(new URL(baoRelayStateQueryUrl).host)) {
                this.baoTYRelaystateURL = baoRelayStateQueryUrl;
            }
            if (baoSamlPostQueryUrl && this.baoTYSamlPostQueryValidUrl.includes(new URL(baoSamlPostQueryUrl).host)) {
                this.baoTYSamlPostURL = baoSamlPostQueryUrl;
            }
            let relayState = this.renderer.createElement('INPUT');
            relayState.type = 'HIDDEN';
            relayState.name = 'relayState';
            relayState.value = this.baoTYRelaystateURL;
            baoLoginForm.appendChild(relayState);
            let SAMLPostURL = this.renderer.createElement('INPUT');
            SAMLPostURL.type = 'HIDDEN';
            SAMLPostURL.name = 'SAMLPostURL';
            SAMLPostURL.value = this.baoTYSamlPostURL;
            baoLoginForm.appendChild(SAMLPostURL);
            let rememberMe = this.renderer.createElement('INPUT');
            rememberMe.type = 'HIDDEN';
            rememberMe.name = 'rememberMe';
            rememberMe.value = this.rememberFlag ? "Y" : "";
            baoLoginForm.appendChild(rememberMe);
        }
        else if (this.loginMode == 'travelLogin') {
            this.baoRelayStateQueryUrl = this._activatedRoute.snapshot.queryParamMap.get('relayState');
            this.baoTravelPageQuery = this._activatedRoute.snapshot.queryParamMap.get('travelPage');
            this.baoLocaleQuery = this._activatedRoute.snapshot.queryParamMap.get('locale');
            let relayState = this.renderer.createElement('INPUT');
            relayState.type = 'HIDDEN';
            relayState.name = 'relayState';
            relayState.value = this.baoRelayStateQueryUrl;
            baoLoginForm.appendChild(relayState);
            let travelPage = this.renderer.createElement('INPUT');
            travelPage.type = 'HIDDEN';
            travelPage.name = 'travelPage';
            travelPage.value = this.baoTravelPageQuery;
            baoLoginForm.appendChild(travelPage);
            let locale = this.renderer.createElement('INPUT');
            locale.type = 'HIDDEN';
            locale.name = 'locale';
            locale.value = this.baoLocaleQuery;
            baoLoginForm.appendChild(locale);
            let rememberMe = this.renderer.createElement('INPUT');
            rememberMe.name = 'rememberMe';
            rememberMe.value = this.rememberFlag ? "Y" : "";
            baoLoginForm.appendChild(rememberMe);
        }
        let digiAppType = this.renderer.createElement('INPUT');
        digiAppType.type = 'HIDDEN';
        digiAppType.name = 'digitalApplicationType';
        digiAppType.value = 'BAO_BROWSER';
        baoLoginForm.appendChild(digiAppType);
        let tmxSessionId = this.renderer.createElement('INPUT');
        tmxSessionId.type = 'HIDDEN';
        tmxSessionId.name = 'tmxSessionId';
        tmxSessionId.value = this._cookieService.getCookie('tmx_sessionid') || '';
        baoLoginForm.appendChild(tmxSessionId);
        let previousLogin = this.renderer.createElement('INPUT');
        previousLogin.type = 'HIDDEN';
        previousLogin.name = 'previousLogin';
        previousLogin.value = this.previousLogin;
        baoLoginForm.appendChild(previousLogin);
        let baoNgaRedirect = this.renderer.createElement('INPUT');
        baoNgaRedirect.type = 'HIDDEN';
        baoNgaRedirect.name = 'NGA_REDIRECTION';
        baoNgaRedirect.value = this.baoNgaRedirection;
        baoLoginForm.appendChild(baoNgaRedirect);
        let ioBlackBox = this.renderer.createElement('INPUT');
        ioBlackBox.type = 'HIDDEN';
        ioBlackBox.name = 'ioBlackBox';
        ioBlackBox.value = this.ioBlackBox;
        baoLoginForm.appendChild(ioBlackBox);
        let deviceprint = this.renderer.createElement('INPUT');
        deviceprint.type = 'HIDDEN';
        deviceprint.name = 'deviceprint';
        deviceprint.value = this.devicePrint;
        baoLoginForm.appendChild(deviceprint);
        this.baoLoginSubmitForm(baoLoginForm);
    }
    baoLoginSubmitForm(form) {
        // Submit the bao login form
        form.submit();
    }
    silentLoginErrorRedirectionCheck(data) {
        if (!this.ngaSilentLoginUseCase) {
            this.messageBehaviourSubject(this.loginServiceMessageObject = data);
        }
        else {
            window.location.href = this._appConfigService.getcsrHostName() + this.ngaSilentLoginErrorRedirectionUrl;
        }
    }
    checkForIVRIntent() {
        let ivrSessionValue = this._storageService.get('ivrintent', StorageService.SESSIONSTORAGE); //
        let ivrCookieValue = this._storageService.get('ivrintent', StorageService.COOKIE); //
        if (ivrSessionValue || ivrCookieValue) {
            this.ivrFlag = true;
        }
    }
    /**
     * @name - profileRefreshAPI
     * @desc - refreshes profile info and retains session activeness
     */
    profileRefreshAPI() {
        const username = this._storageService.get('SessionRecoveryCookie', StorageService.COOKIE);
        const requestBody = {
            userId: username
        };
        this._loginValidationService.profileRefreshAPI(requestBody).subscribe({
            next: (res) => {
                if (res) {
                    this.cbolConfigLoad.emit();
                    this.profileRefreshStatus.emit(true);
                }
            },
            error: (err) => {
                this.signOffFlow({ 'error': 'Profile refresh eror' });
            }
        });
    }
    /**
     * @name partnerSignOnSubmit
     * @desc - performs login request for partners
     * @param userId
     * @param password
     * @param rememberUserIdFlag
     * @param renderer
     * @param ngaSilentLoginUseCase
     * @param queryParams
     * @param successRedirectUrl
     * @param featureId
     * @param isPartner
     * @param tenantId
     * @param loginMode
     * @param skipBiztokenClear
     * @param passMan - to log whether password manager (auto-fill) was used in the input fields
     * @param originFlow - determine where the login service is invoked from (fuip, partner login etc.)
     * @returns
     */
    async partnerSignOnSubmit(userId = '', password = '', rememberUserIdFlag, renderer, ngaSilentLoginUseCase, queryParams, successRedirectUrl, featureId, isPartner, tenantId, loginMode, skipBiztokenClear, passMan, originFlow) {
        if (passMan) {
            this.passMan = passMan;
        }
        /* Adding Origin Flow here to accomodate last minute MFA Redirection Fix.
        This is a TEPMORARY measure and a better solution should be made in future. */
        if (!originFlow) {
            originFlow = 'login';
        }
        this.loginOrigin = 'partner';
        // Remove white spaces trim()
        userId = userId.trim();
        password = password.trim();
        this.loginSuccessRedirectUrl = successRedirectUrl || this.constants.getAppConstants()['APIUrls']['loginSuccessRedirectUrl'];
        if (isPartner) {
            this.partnerAPI = true;
        }
        if (tenantId) {
            this._tenantId = tenantId;
        }
        // TODO: Generalize partner endpoints
        if (this._tenantId === 'zelle' || this._tenantId === 'acquisition' || this._tenantId === 'citishop' || this._tenantId === 'flexpay') {
            this._channelId = "CBOL";
        }
        else if (this._tenantId === 'amazon') {
            this._channelId = "INTERNET";
            this._appConfigService.setChannelId("INTERNET");
        }
        // generate new TMX id
        let tmxSessionId = Cookie.get('tmx_sessionid') || '';
        if (tmxSessionId === '') {
            console.log("TMX session ID is Null, invoking TMX profile call for Partner-Login signon");
            this.tmxService.getRequestParams();
        }
        ;
        // Clear Authorization and bizToken to get fresh bizToken generated before submit
        this._ngaLoginUtilityService.clearSessionCookies(skipBiztokenClear, true);
        // Intialize userid and password
        this.userId = userId;
        this.pwd = password;
        this.rememberFlag = rememberUserIdFlag;
        this.renderer = renderer;
        this.ngaSilentLoginUseCase = ngaSilentLoginUseCase;
        this.captureFidoResponse();
        this.captureBiocatchSessionId();
        // Store queryParams value
        if (queryParams != null && queryParams != '') {
            this.queryParams = queryParams;
        }
        //Passing loginMode value for bao multiple redirection.
        if (loginMode != null && loginMode != '') {
            this.loginMode = loginMode;
        }
        else {
            this.loginMode = 'MKTLOGIN';
        }
        // Fetch feature Id so that this can be passed as a header in login request
        if (featureId) {
            this.featureId = featureId;
        }
        // Blank user id or password
        if (this.userId.length === 0 || this.pwd.length === 0) {
            console.log('Location: NGA-login-service - userid/ password was blank');
            this.silentLoginErrorRedirectionCheck({ ngaLoginNoRedirectionFlowUnkownError: true, ngaLoginResponse: { 'error': 'userid or passowrd was blank' } });
            return;
        }
        // * If session tokens are not required to be cleared - current_usecases = ['FUIP Retrieve UserID Login']
        if (skipBiztokenClear) {
            this.partnerE2eSignOn(originFlow);
            return;
        }
        // * Wait till the HTTPOnly session tokens are cleared and then make the login call
        // TODO: Generalize the logic - maybe pass an argument to decide suppression?
        if (this._tenantId !== 'citishop' || originFlow === 'fuip') {
            await this._httpService.deleteSessions();
        }
        // * proceed to clear session tokens and e2e eventid
        this._ngaLoginUtilityService.clearSessionsFallbackMode();
        this.partnerE2eSignOn(originFlow);
    }
    async partnerE2eSignOn(originFlow) {
        try {
            let partnerLoginReqBody;
            let pass = await this.encryptInputString(this.pwd, 'password');
            if (!pass) {
                throw new Error('Encryption returned empty');
            }
            partnerLoginReqBody = {
                userId: this.userId,
                password: pass,
                ...this.passMan
            };
            if (this._tenantId === "citishop") {
                this.environmentId = "partnerLoginAuth";
            }
            if (this.rememberFlag !== null && this.rememberFlag !== undefined) { // To check if remember flag is set
                partnerLoginReqBody['rememberUserIdFlag'] = this.rememberFlag;
            }
            const customHeaders = {
                'channelId': this._channelId,
                'tenantId': this._tenantId,
                'environmentId': this.environmentId ? this.environmentId : 'loginAuth'
            };
            this._loginValidationService.partnerUserIdAndPwdValidation(partnerLoginReqBody, this.loginFlowSuccessHandler, this.loginFlowErrorHandler, customHeaders, this._tenantId, originFlow);
        }
        catch (error) {
            let errorObj = { e2eEncriptionError: true, ngaLoginNoRedirectionFlow500Error: true, ngaLoginResponse: error };
            this.setLoginServiceMessageObject(errorObj);
            return EMPTY;
        }
    }
    partnerNone2eSignOn() {
        let partnerLoginReqBody;
        // Take care of silent login scenario
        if (!this.ngaSilentLoginRequestBodyFlag) {
            partnerLoginReqBody = {
                userId: this.userId,
                password: this.pwd,
                ...this.passMan
            };
        }
        else {
            partnerLoginReqBody = {
                userId: this.userId,
                authResumeToken: this.silentLoginToken
            };
        }
        // add ccsId and qrWebToken to request body for QR code login
        if (this.qrCodeLoginRequestBodyFlag) {
            partnerLoginReqBody = {
                userId: this.userId,
                ccsId: this.ccsId,
                qrWebToken: this.qrWebToken
            };
        }
        const customHeaders = {
            'environmentId': (this.qrCodeLoginRequestBodyFlag || this.ngaSilentLoginRequestBodyFlag) ? this.e2eEnvId : this.nonE2eEnvId,
            'channelId': this._channelId,
            'tenantId': this._tenantId
        };
        // allow BAU login in same page if QR code login fails
        this.qrCodeLoginRequestBodyFlag = false;
        this.ngaSilentLoginRequestBodyFlag = false;
        this._loginValidationService.partnerUserIdAndPwdValidation(partnerLoginReqBody, this.loginFlowSuccessHandler, this.loginFlowErrorHandler, customHeaders, this._tenantId);
    }
    getDeviceType() {
        const ua = navigator.userAgent;
        const tabletRegex = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i;
        const mobRegex = /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/;
        if (tabletRegex.test(ua))
            return "tablet";
        if (mobRegex.test(ua))
            return "mobile";
        return "desktop";
    }
    getBrowserName() {
        const agent = window.navigator.userAgent.toLowerCase();
        switch (true) {
            case agent.indexOf('edg') > -1:
                return 'edge';
            case agent.indexOf('opr') > -1 && !!window.opr:
                return 'opera';
            case agent.indexOf('chrome') > -1 && !!window.chrome:
                return 'chrome';
            case agent.indexOf('trident') > -1:
                return 'ie';
            case agent.indexOf('firefox') > -1:
                return 'firefox';
            case agent.indexOf('safari') > -1:
                return 'safari';
            default:
                return 'other';
        }
    }
    getOS() {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.toLowerCase().indexOf('win') !== -1) {
            return 'Windows';
        }
        else if (userAgent.toLowerCase().indexOf('mac') !== -1) {
            if (userAgent.toLowerCase().indexOf('iphone') !== -1) {
                return 'iOS';
            }
            else
                return 'macOS';
        }
        else if (userAgent.toLowerCase().indexOf('linux') !== -1) {
            return 'Linux';
        }
        else if (userAgent.toLowerCase().indexOf('android') !== -1) {
            return 'Android';
        }
        else {
            return 'Unknown OS';
        }
    }
    callErrorLoggingApi(responseTime, numberOfAccounts, customerType, ccsId, uuid, customerSegment, isEndToEndWebLoginSpeedCaptureEnabled) {
        if ('connection' in navigator) {
            // API is supported
            // Access connection information
            this.connection = navigator.connection;
            this.networkType = this.connection ? this.connection.effectiveType : 'unknown';
            this.deviceType = this.getDeviceType();
            this.browserName = this.getBrowserName();
            this.os = this.getOS();
            this.connection.addEventListener('change', () => {
                this.networkType = this.connection ? this.connection.effectiveType : 'unknown';
            });
        }
        else {
            // API is not supported, handle accordingly
            console.warn('Network Information API is not supported in this browser.');
        }
        if (isEndToEndWebLoginSpeedCaptureEnabled) {
            this.setSpeedLoginCookie('responseTime', responseTime);
            this.setSpeedLoginCookie('userId', this.userId);
            this.setSpeedLoginCookie('numberOfAccounts', numberOfAccounts.toString());
            this.setSpeedLoginCookie('customerType', customerType);
            this.setSpeedLoginCookie('disruption', "false");
            this.setSpeedLoginCookie('loginType', this.isQrLogin ? "QR" : "PASSWORD");
            this.setSpeedLoginCookie('networkType', this.networkType);
            this.setSpeedLoginCookie('ccsId', ccsId);
            this.setSpeedLoginCookie('deviceType', this.deviceType);
            this.setSpeedLoginCookie('browserType', this.browserName);
            this.setSpeedLoginCookie('os', this.os);
            this.setSpeedLoginCookie('uuid', uuid);
            this.setSpeedLoginCookie('test', this.test ? "true" : "false");
            this.setSpeedLoginCookie('tenantId', this.tenantId);
            this.setSpeedLoginCookie('customerSegment', customerSegment);
        }
        else {
            let httpBody = {
                "userId": this.userId,
                "errorCode": "Web_1000",
                "tenantId": this.tenantId,
                "responseTime": responseTime,
                "numberOfAccounts": numberOfAccounts,
                "additionalInfo": {
                    "customerType": customerType,
                    "disruption": false,
                    "loginType": this.isQrLogin ? "QR" : "PASSWORD",
                    "test": this.test,
                    "uuid": uuid,
                    "networkType": this.networkType,
                    "ccsId": ccsId,
                    "deviceType": this.deviceType,
                    "browserType": this.browserName,
                    "os": this.os
                }
            };
            this._httpService.post('/prelogin/digital/reporting/userInterface/errorLogging', httpBody).subscribe();
        }
    }
    setSpeedLoginCookie(name, value) {
        Cookie.set(`speedLogin_${name}`, value, null, '/', '.citi.com', true);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginService, deps: [{ token: i1.AppConfigService }, { token: i1.StorageService }, { token: NGALoginValidationService }, { token: i1.CookieService }, { token: i5.Router }, { token: i5.ActivatedRoute }, { token: i4.TMXService }, { token: i4.E2eService }, { token: i1.DataCollectorService }, { token: NGALoginServiceConstants }, { token: BAOLoginServiceConstants }, { token: NGALoginUtilityService }, { token: i3.UnmanagedCookieService }, { token: TaggingService }, { token: i1$1.HttpService }, { token: i1.FeatureDetectionService }, { token: i2.MfaUtilityService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NGALoginService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.AppConfigService }, { type: i1.StorageService }, { type: NGALoginValidationService }, { type: i1.CookieService }, { type: i5.Router }, { type: i5.ActivatedRoute }, { type: i4.TMXService }, { type: i4.E2eService }, { type: i1.DataCollectorService }, { type: NGALoginServiceConstants }, { type: BAOLoginServiceConstants }, { type: NGALoginUtilityService }, { type: i3.UnmanagedCookieService }, { type: TaggingService }, { type: i1$1.HttpService }, { type: i1.FeatureDetectionService }, { type: i2.MfaUtilityService }], propDecorators: { cbolConfigLoad: [{
                type: Output
            }], profileRefreshStatus: [{
                type: Output
            }] } });

class NgaLoginServiceModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NgaLoginServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: NgaLoginServiceModule, imports: [CoreCommonModule,
            NGALoginServiceRoutingModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NgaLoginServiceModule, providers: [
            NGALoginValidationService, MfaUtilityService, NGALoginService, NGALoginServiceConstants, BAOLoginServiceConstants, NGALoginUtilityService, UnmanagedCookieService, TaggingService
        ], imports: [CoreCommonModule,
            NGALoginServiceRoutingModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: NgaLoginServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CoreCommonModule,
                        NGALoginServiceRoutingModule
                    ],
                    exports: [],
                    providers: [
                        NGALoginValidationService, MfaUtilityService, NGALoginService, NGALoginServiceConstants, BAOLoginServiceConstants, NGALoginUtilityService, UnmanagedCookieService, TaggingService
                    ]
                }]
        }] });

class AEMFeatureFlagResolver {
    constructor(_httpService) {
        this._httpService = _httpService;
    }
    async resolve(route, state) {
        try {
            const isAEMEnabledRulesConfig = await firstValueFrom(this._httpService.get("/config", { headers: { channelId: "CBOL" } }));
            console.log('Location: NGA-aem-feature-service.ts, rules config case.');
            const config = isAEMEnabledRulesConfig["US_GCB_CBOL"]["cbol_AEM_flags"][route.data.aemFeatureFlagForResolver];
            console.log("Service Response Config >> ", config);
            this.config = config;
            console.log("isAEMEnabled: ", this.config.isAEMEnabled);
            console.log("Config: ", this.config);
            if (this.config?.hasOwnProperty("isAEMEnabled")) {
            }
            return this.config.isAEMEnabled;
        }
        catch (error) {
            console.log("AEM feature flag retrieval error", error);
            return false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AEMFeatureFlagResolver, deps: [{ token: i1$1.HttpService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AEMFeatureFlagResolver, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AEMFeatureFlagResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: () => [{ type: i1$1.HttpService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AEMFeatureFlagResolver, NGALoginService, NGALoginServiceConstants, NGALoginServiceRoutingModule, NGALoginUtilityService, NGALoginValidationService, NgaLoginServiceModule };
